import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export enum DownloadToastTypeEnum {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  NO_RESULTS = 'NO_RESULTS',
}

export interface FileDirectoryDownloadResponseData {
  blob: Blob;
  name: string;
  responseStatus?: number;
}

export type FileDirectoryDownloadResponse =
  | {
      data: FileDirectoryDownloadResponseData;
      error?: never;
    }
  | {
      data?: never;
      error: FetchBaseQueryError | SerializedError;
    };
